// The admin settings-row language — ONE row anatomy for every toggle /
// config surface (/admin/flags, dashboard-defaults, analytics, module
// panels, activity-scoring, teams permissions): name + optional
// sub-line on the left, the control cluster on the right, hairline
// dividers between rows inside a card. (2026-07-25 per Nika
// "/dashboard-defaults and /flags should have similar ui and all other
// toggled pages".)
//
// Text resolution: rows are usually fed as childrenAs:'state' — Name
// reads s.label (then s.title/el.label), Sub reads s.description (then
// el.description) and hides when empty. Consumers put controls in
// `Right` (SwitchInput, inputs, captions) and may override Name/Sub
// factories freely.
//
// Both strings go through polyglot, so a row may carry a bundle KEY in
// `label` / `description` (the KEY-IN-STATE form — /admin/dashboard-defaults
// and /admin/analytics feed the catalog that way). polyglot returns anything
// that is not a key verbatim, so a module's own declared widget name, a
// feature-flag registry label and a person's name all pass straight through
// untouched.
export const SettingRow = {
  flow: 'x',
  align: 'center space-between',
  gap: 'B',
  padding: 'A 0',
  // Was a `borderBottom: 'hairline solid line'` + `:last-child` clear —
  // row-separator-as-stroke, banned by design-direction.md §8 / DESIGN_
  // LANGUAGE §2.5 ("row separators inside rounded cards stay banned — gap +
  // hover tint instead"). Each row's own top+bottom `A` padding already
  // gives adjacent rows a full 2×A whitespace gap (flex padding never
  // collapses between siblings), so removing the line changes the geometry
  // not at all; the hover wash below is the fill-contrast replacement for
  // the boundary cue the border used to carry.
  transition: 'Z defaultBezier background',
  ':hover': { background: 'hover' },
  '@mobileL': { flexWrap: 'wrap', gap: 'Z' },

  Info: {
    flow: 'y',
    gap: 'V',
    minWidth: '0',
    flex: '1',

    Name: {
      tag: 'h4',
      margin: '0',
      fontSize: 'Z2',
      fontWeight: '700',
      color: 'title',
      text: (el, s) => el.call('polyglot', el.parent?.parent?.label || s.label || s.title || '')
    },
    Sub: {
      tag: 'p',
      margin: '0',
      fontSize: 'Y2',
      color: 'caption',
      lineHeight: '1.45',
      hide: (el, s) => !(el.parent?.parent?.description || s.description),
      text: (el, s) => el.call('polyglot', el.parent?.parent?.description || s.description || '')
    }
  },

  Right: {
    flow: 'x',
    align: 'center',
    gap: 'Z',
    flexShrink: '0'
  }
}
